import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { TestChatWrapper, TestChatContainer } from './TestChat.styled';
import { useAgent } from '../../context';
import { useStore } from '../../../../../hooks';
import ChatComponentPersistent from '../../../PMSystemPage/components/ChatComponent/ChatComponentPersistent';
import { ChatProvider } from '../../../PMSystemPage/context/ChatContext';

const TestChat = () => {
  const { agentId } = useParams();
  const { authStore } = useStore();
  const { agent } = useAgent();

  // Configuración del placeholder
  const placeholderConfig = useMemo(() => ({
    placeholderTitle: 'Test your Agent',
    placeholderDescription: 'Use this simulated chat to see how your agent responds\nSend a message to preview its behavior.',
    placeholderIcon: ChatBubbleOutlineRoundedIcon,
    showDefaultPlaceholder: true,
    chatStarters: agent.starters || [],
  }), [agent.starters]);

  // Configuración HTTP
  const httpOptions = useMemo(() => ({
    tenantId: authStore.selectedAccount?.tenantId || 'default-tenant',
    senderUuid: authStore.selectedAccount?.id,
    assistantUuid: agentId,
  }), [authStore.selectedAccount, agentId]);

  // Datos del agente para el chat
  const agentData = useMemo(() => ({
    id: agentId,
    customerId: authStore.selectedAccount?.id,
    jobTitle: '',
    persona: { name: '' },
    tone: [],
    conversationStarters: agent.starters || [],
    extendedAnswer: false,
    scope: '',
    actions: [],
    actionsSettings: [],
    name: agent.name || 'Agent',
    knowledgeBase: [],
    humanInstructions: agent.instructions || '',
    prompt: '',
    addToConcierge: false,
    channels: [],
    fullInstructions: '',
    guardrails: [],
    features: [],
    instructionRef: [],
    status: agent.status || 'active',
    photoUrl: agent.metadata?.imageUrl || '',
    model: agent.model || '',
    category: agent.category || '',
    signature: { EMAIL: '' },
    type: agent.type || 'assistant',
    promptId: '',
    createdBy: '',
  }), [agentId, authStore.selectedAccount, agent]);

  return (
    <TestChatContainer>
      <TestChatWrapper>
        <ChatProvider
          communicationType="http"
          httpOptions={httpOptions}
        >
          <ChatComponentPersistent
            customerSelected={authStore.selectedAccount?.id}
            agentId={agentId}
            agentDomain="assistant"
            inputWidth="100%"
            metadata={{}}
            handleMetadata={() => {}}
            agentData={agentData}
            {...placeholderConfig}
          />
        </ChatProvider>
      </TestChatWrapper>
    </TestChatContainer>
  );
};

export default TestChat;

